import {
    Component, OnInit,
    Input, Output,
    EventEmitter,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
} from '@angular/core';
import { PageData } from './pager.model';

@Component({
    selector: 'jui-pager',
    template: `
      <div class="jui-pager" [style.height.px]="height"
          *ngIf="this.page.total > 0">
          <div class="jpager-left" [style.line-height.px]="height"
              *ngIf="showInfo" [style.float]="align!=='right'?'left': 'right'">
              {{page.start + 1}} - {{page.end}}条，共{{page.total}}条
          </div>
          <div class="jpager-right" [style.float]="align!=='left'?'right': 'left'">
              <div class="inner jump">
                  <div class="addition-wrap">
                      <label class="desc" *ngIf="showJumpTool">转到:
                          <jui-select [selected]="page.curPage + 1" 
                              (selectedChange)="onPageNoChange($event)"
                              [dataSrc]="page.allPageNos"
                              minWidth="50" [height]="height">
                          </jui-select>页
                      </label>
                      <span *ngIf="showTotalPages">/ 共{{page.totalPage}}页</span>
                  </div>
                  <div class="addition-wrap" *ngIf="showPageTool">
                      <label class="desc">每页:
                          <jui-select [(selected)]="page.pageSize"
                              (selectedChange)="onSizeChange($event)"
                              [dataSrc]="page.pageSizeOpts"
                              minWidth="50" [height]="height">
                          </jui-select>条
                      </label>
                  </div>
              </div>
              <div class="inner page-nos">
                  <ul>
                      <li (click)="goFirstPage()" [ngClass]="page.curPage !== 0 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">«</a>
                      </li>
                      <li (click)="goPrevPage()" [ngClass]="page.curPage !== 0 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">‹</a>
                      </li>
                      <li (click)="selectPage(index)"
                          *ngFor="let index of page.pageNos"
                          [ngClass]="index === page.curPage + 1 ? 'active' : 'clickable' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">{{index}}</a>
                      </li>
                      <li (click)="goNextPage()" [ngClass]="page.curPage !== page.totalPage - 1 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">›</a>
                      </li>
                      <li (click)="goLastPage()" [ngClass]="page.curPage !== page.totalPage - 1 ? 'clickable' : 'disabled' ">
                          <a href="javascript:void(0);"
                              [style.width.px]="height"
                              [style.height.px]="height - 2">»</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      jui-pager .jui-pager {
        width: 100%; }
        jui-pager .jui-pager .hidden {
          display: none; }
        jui-pager .jui-pager .jpager-left {
          float: left;
          margin-left: 0;
          font-size: 12px;
          color: #4190EE; }
        jui-pager .jui-pager .jpager-right {
          margin-right: 0;
          display: inline-block;
          font-size: 12px;
          float: right; }
          jui-pager .jui-pager .jpager-right .inner {
            float: left;
            margin-left: 5px; }
            jui-pager .jui-pager .jpager-right .inner p {
              float: left; }
            jui-pager .jui-pager .jpager-right .inner .addition-wrap {
              float: left;
              margin: 0 5px; }
              jui-pager .jui-pager .jpager-right .inner .addition-wrap .jui-select {
                margin: 0 5px; }
          jui-pager .jui-pager .jpager-right .page-nos ul {
            height: 30px;
            border: 1px solid #d0d0d0;
            border-radius: 2px;
            padding: 0px; }
            jui-pager .jui-pager .jpager-right .page-nos ul li {
              list-style: none;
              float: left;
              border-right: 1px solid #d0d0d0;
              cursor: pointer; }
              jui-pager .jui-pager .jpager-right .page-nos ul li.disabled a {
                color: #ccc; }
              jui-pager .jui-pager .jpager-right .page-nos ul li a {
                position: relative;
                font-size: 12px;
                display: block;
                line-height: 28px;
                text-align: center;
                text-decoration: none;
                color: #4190EE; }
              jui-pager .jui-pager .jpager-right .page-nos ul li:last-child {
                border-right: none; }
              jui-pager .jui-pager .jpager-right .page-nos ul li.clickable:hover {
                background-color: #eee; }
              jui-pager .jui-pager .jpager-right .page-nos ul li.active {
                background-color: #4190EE; }
              jui-pager .jui-pager .jpager-right .page-nos ul li.active:hover {
                border-color: #4190EE; }
              jui-pager .jui-pager .jpager-right .page-nos ul li.active a {
                color: #fff; }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PagerComponent implements OnInit {
    @Input()
    public page: PageData;
    @Input()
    public height = 30;
    @Input()
    public align = 'normal'; // normal, left, right

    @Output()
    public pageSizeChange: EventEmitter<any> = new EventEmitter();
    @Output()
    public pageChange: EventEmitter<any> = new EventEmitter();
    @Output()
    public listChange: EventEmitter<any> = new EventEmitter();

    // 是否显示
    @Input()
    public showInfo = true;
    @Input()
    public showJumpTool = true;
    @Input()
    public showTotalPages = true;
    @Input()
    public showPageTool = true;

    @Input()
    public set type(style) {
        this._style = style;
        if (style === 'simple') {
            this.showInfo = false;
            this.showJumpTool = false;
            this.showTotalPages = false;
            this.showPageTool = false;
        }
    }

    private _style = 'normal';

    constructor(private changeDetectionRef: ChangeDetectorRef) {
        // pass
    }

    public ngOnInit() {
        this.init();
    }

    // 点击页码
    public selectPage(pageNo: number) {
        if ( this.page.curPage === pageNo - 1 || pageNo < 1 ||
            pageNo > this.page.totalPage ) {
            return;
        }
        this.page.goto(pageNo);

        // this.pageChange.emit(this.page.curPage);
        this.updatePageNos();
    }
    public onPageNoChange(pageNo) {
        this.page.curPage = pageNo - 1;
        // this.pageChange.emit(this.page.curPage);
        this.updatePageNos();
    }
    public onSizeChange(event) {
        if (this.page.curPage !== 0) {
            this.page.goFirstPage();
        } else {
            this.page.listChanged();
            // this.listChange.emit(this.page.lacks);
        }
        this.updatePageNos();

        // this.pageSizeChange.emit(this.page.pageSize);
    }
    public goFirstPage() {
        this.page.goFirstPage();
    }
    public goLastPage() {
        this.page.goLastPage();
    }
    public goPrevPage() {
        this.page.goPrevPage();
    }
    public goNextPage() {
        // this.page.curPage ++;
        this.page.goNextPage();
    }

    private updatePageNos() {
        this.page.updatePageNos();
    }

    // 初始化标签
    private init() {
        if (!this.page) {
            this.page = new PageData();
        }
        this.page.setChangeDetector(this.changeDetectionRef);
        this.page.setPageChanger(this.pageChange);
        this.page.setPageSizeChanger(this.pageSizeChange);
        this.page.setListChanger(this.listChange);
        // 初始化的时候，触发一次
        this.page.init();
    }

}
